<template>
  <div class="view pa24">
    <el-form :model="form" label-width="120px">
      <el-form-item :label="$t('addedServices', 'menuStatus') + ':'">
        <el-switch
          v-model="form.statusLeft"
          :active-text="$t('addedServices', 'turnOn')"
          :inactive-text="$t('addedServices', 'turnOff')"
        >
        </el-switch>
      </el-form-item>
      <el-form-item :label="$t('addedServices', 'menuNameLeft') + ':'">
        <div class="d-flex">
          <el-input
            type="text"
            :placeholder="$t('addedServices', 'pleaseEnterContent')"
            v-model="form.nameLeft"
            style="width: 200px"
            class="mr20"
            maxlength="4"
          ></el-input>
          <p class="cA3">{{ $t('addedServices', 'note') }}</p>
        </div>
      </el-form-item>
      <el-form-item :label="$t('addedServices', 'topCarousel') + ':'">
        <div class="d-flex">
          <el-upload
            action="https://api.domo.hk/file/uploadObjectOSS"
            list-type="picture"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :file-list="form.fileListLeft"
            :auto-upload="true"
          >
            <el-button size="small" type="primary">{{ $t('addedServices', 'clickToUpload') }}</el-button>
            <div slot="tip" class="el-upload__tip">
              {{ $t('addedServices', 'uploadImageTip') }}
            </div>
          </el-upload>
        </div>
          
      </el-form-item>

      <el-divider></el-divider>

      <el-form-item :label="$t('addedServices', 'menuStatus') + ':'">
        <el-switch
          v-model="form.statusRight"
          :active-text="$t('addedServices', 'turnOn')"
          :inactive-text="$t('addedServices', 'turnOff')"
        >
        </el-switch>
      </el-form-item>
      <el-form-item :label="$t('addedServices', 'menuNameRight') + ':'">
        <div class="d-flex">
          <el-input
            type="text"
            :placeholder="$t('addedServices', 'pleaseEnterContent')"
            v-model="form.nameRight"
            style="width: 200px"
            class="mr20"
            maxlength="4"
          ></el-input>
          <p class="cA3">{{ $t('addedServices', 'note2') }}</p>
        </div>
      </el-form-item>
      <el-form-item :label="$t('addedServices', 'topCarousel') + ':'">
        <el-upload
          action="https://api.domo.hk/file/uploadObjectOSS"
          list-type="picture"
          :on-remove="handleRemoveRight"
          :on-success="handleAvatarSuccessRight"
          :before-upload="beforeAvatarUploadRight"
          :file-list="form.fileListRight"
          :auto-upload="true"
        >
          <el-button size="small" type="primary">{{ $t('addedServices', 'clickToUpload') }}</el-button>
          <div slot="tip" class="el-upload__tip">
            {{ $t('addedServices', 'uploadImageTip') }}
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button
          style="background-color: #51cdcb; color: white"
          @click="saveSetting"
          >{{ $t('addedServices', 'save') }}</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18nMixin';
import {
  updateCustomizeSetting,
  queryCustomizeSetting,
} from "@/api/addedServices";
export default {
  mixins: [i18nMixin],
  data() {
    return {
      form: {
        fileListRight: [],
        rightImg: "",
        leftImage: "",
        nameLeft: "",
        statusLeft: false,
        fileListLeft: [],
        statusRight: false,
        nameRight: "",
      },
    };
  },
  created() {
    this.queryCustomizeSetting();
  },
  methods: {
    handleRemove(file, fileList) {
      const index = this.form.fileListLeft.findIndex(
        (item) => item.url == file.url
      );
      if (index > -1) {
        this.form.fileListLeft.splice(index, 1);
      }
    },
    handleRemoveRight(file) {
      const index = this.form.fileListRight.findIndex(
        (item) => item.url == file.url
      );
      if (index > -1) {
        this.form.fileListRight.splice(index, 1);
      }
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        file.url = `https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/${res.data}`;
        this.form.fileListLeft.push(file);
      }
    },
    handleAvatarSuccessRight(res, file) {
      if (res.code == 200) {
        file.url = `https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/${res.data}`;
        this.form.fileListRight.push(file);
      }
    },
    beforeAvatarUploadRight(file) {
      if (this.form.fileListRight.length >= 6) {
        this.$message.msg(this.$t('addedServices', 'uploadImageCountError'));
        return false;
      } else {
        const isJPG = file.type === "image/jpeg";
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error(this.$t('addedServices', 'uploadImageFormatError'));
        }
        if (!isLt2M) {
          this.$message.error(this.$t('addedServices', 'uploadImageSizeError'));
        }
        return isJPG && isLt2M;
      }
    },
    beforeAvatarUpload(file) {
      if (this.form.fileListLeft.length >= 6) {
        this.$message.msg(this.$t('addedServices', 'uploadImageCountError'));
        return false;
      } else {
        const isJPG = file.type === "image/jpeg";
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error(this.$t('addedServices', 'uploadImageFormatError'));
        }
        if (!isLt2M) {
          this.$message.error(this.$t('addedServices', 'uploadImageSizeError'));
        }
        return isJPG && isLt2M;
      }
    },
    async saveSetting() {
      if (this.form.fileListLeft.length == 0) {
        this.$message.msg(this.$t('addedServices', 'leftSideUploadError'));
        return;
      }
      if (this.form.fileListRight.length == 0) {
        this.$message.msg(this.$t('addedServices', 'rightSideUploadError'));
        return;
      }
      this.form.rightImg = JSON.stringify(
        this.form.fileListRight.map((item) => {
          return item.url;
        })
      );
      this.form.leftImage = JSON.stringify(
        this.form.fileListLeft.map((item) => {
          return item.url;
        })
      );
      try {
        await updateCustomizeSetting(this.form);
        this.$message({
          message: this.$t('addedServices', 'saveSuccess'),
          type:'success'
        })
      } catch (error) {
        console.log(error);
      }
    },
    async queryCustomizeSetting() {
      const result = await queryCustomizeSetting(
        { pageSize: 0 },
        { showLoading: true }
      );
      const { data } = result;
      if (data && data.settingId) {

        this.form = data;
        if (data.leftImage) {
          const left = JSON.parse(data.leftImage);
          this.form.fileListLeft = [];
          left.forEach((item, index) => {
            this.form.fileListLeft.push({ uid: index, url: item });
          });
          this.form.fileListLeft = this.form.fileListLeft;
        }
        if (data.rightImg) {
          const right = JSON.parse(data.rightImg);
          this.form.fileListRight = [];
          right.forEach((item, index) => {
            this.form.fileListRight.push({ uid: index, url: item });
          });
          this.form.fileListRight = this.form.fileListRight;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-upload-list__item{
  width: 100px;
  display: inline-block;
  margin-right: 10px;
}
</style>